import { withTranslation } from '@sailor/i18n-mach-pro';
import { connect } from '@wmfe/mach-pro-store';
import { RootState } from '@/src/pages/homepage/home_page_main/models/store';
import React from 'react';
import { attachments } from '@/src/components/HomePage/ContentItems';
import GroupMealTag from '@/src/components/HomePage/GroupMealTag';
import './index.css';
import { cloneDeep } from 'lodash';
import { reportBizCardMetrics, findTargetFromMatrix } from '@/src/utils/bizCardReporter';
import { ContentSpecType } from '../ContentItems/itemSuperCard/itemSuperCard';
import { OfferDishesCardLxViewbid, OfferDishesCardLxClickbid } from './constant';
import { ModuleItemProps } from '../common/interface';

const WMRouter = Mach.requireModule('Router');
const Statistics = Mach.requireModule('Statistics');

const mapStateToProps = (state: RootState) => ({
  feedAPIData: state.global?.feedAPIData,
  pageNo: state.global?.pageNo,
});

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface IProps extends BaseIProps, ModuleItemProps {
}
interface IState {
}

class DishCard extends React.Component<IProps, IState> {
  biz_trace_id = ''
  observer: any = null;

  constructor(props) {
    super(props);
    this.biz_trace_id = props.pageLogData?.biz_trace_id || '-999';
  }

  attrChecker = (): void => {
    const data = this.props?.apiData?.json_data || {};
    const {
      shopMainPicUrl, content, pictures, scheme
    } = data || {};

    const shopNameMissing = findTargetFromMatrix(content, 'shopName')?.name ? 0 : 1;
    const shopJumpUrlMissing = scheme ? 0 : 1;

    const picObject = pictures?.[0] || {};
    const dishMainPicMissing = shopMainPicUrl || picObject.url ? 0 : 1;
    const dishNameMissing = findTargetFromMatrix(content, 'spuName')?.name || findTargetFromMatrix(content, 'spuDesc')?.description ? 0 : 1;
    const dishJumpUrlMissing = picObject.scheme ? 0 : 1;
    reportBizCardMetrics({
      params: {
        shopNameMissing,
        shopJumpUrlMissing,
        dishJumpUrlMissing,
        dishNameMissing,
        dishMainPicMissing,
      },
      tags: {
        channel: '菜品商卡'
      }
    });
  }

  componentWillUnmount() {
    this.removeObserver();
  }

  private navigateTo(scheme?: string) {
    if (scheme) {
      WMRouter.navigateTo(scheme, {}, () => {});
    }
  }

  private getCid = () => {
    const { cid = '' } = this.props.apiData?.log_info || {};
    return cid;
  }

  /**
     * 曝光监听
     */
  observerCellAppear = () => {
    this.removeObserver();
    if (globalThis?.eventBus?.subscribeCellAppear) { // 新主包通过监听appear通知上报MV
      this.observer = globalThis?.eventBus?.subscribeCellAppear?.(this.props.apiData?.indexPath, () => {
        this.lxReportOnShow(this.props.apiData);
      });
    }
  }

  removeObserver = () => {
    if (!this.observer) {
      // console.log('removeObserver ======> return', this.props.apiData.indexPath);
      return;
    }

    this.observer?.unSubscribe?.();
  }

  private lxReportOnShow = (apiData) => {
    const { json_data: data } = apiData || {};
    if (data?.isMV) {
      return;
    }

    this.attrChecker();
    // 由于外部传入的时 CloneDeep 的数据，在列表数据更新时会导致 isMv 标志丢失, 造成 MV 上报重复，所以需要在全局做 MV 上报记录
    // 一人食页面切换自取外卖tab是item值一样会进行错误去重，因此key值加入场景name做区分，避免错误去重
    const mvKey = `${apiData?.indexPath?.item}_${data.logData?.scene_name}_key`;
    if (globalThis.homeProductCardMVHistory === undefined) {
      globalThis.homeProductCardMVHistory = {};
    }
    const bizTraceId = this.biz_trace_id;
    // 如果第一个卡片要被重新曝光了，证明筛选条件已经发生变化或发生刷新，需要清空全局历史上报记录
    if (apiData?.indexPath?.item === 0 && this.props.pageNo === 0 && bizTraceId !== globalThis.lastBizTraceId) {
      // 第一个数据会进行多次渲染，防止多次清空
      if (!this.props.feedAPIData?.isClearHomeProductCardMVHistory) {
        console.log('FeedProductBigPicCard lxReportOnShow clear history');
        globalThis.homeProductCardMVHistory = {};
        this.props.feedAPIData.isClearHomeProductCardMVHistory = true;
      }
    }
    if (globalThis.homeProductCardMVHistory[mvKey]) {
      return;
    }
    globalThis.lastBizTraceId = bizTraceId;
    const cid = this.getCid();
    const parm = this.lxParm();
    Statistics.view(cid, OfferDishesCardLxViewbid, parm);
    data.isMV = true;
    globalThis.homeProductCardMVHistory[mvKey] = true;
  }

  private lxReportOnClick = (scheme) => {
    this.navigateTo(scheme);

    const cid = this.getCid();

    const parm = this.lxParm();
    Statistics.setTag && Statistics.setTag('sailor_c', {
      [cid]: {
        ...parm,
        OfferDishesCardLxClickbid,
      },
    });
    Statistics.click(cid, OfferDishesCardLxClickbid, parm);
  }

  private lxParm() {
    const parm = this.props.apiData?.json_data?.logData || {};
    return { spu_index: this.props.apiData?.indexPath?.item, biz_trace_id: this.biz_trace_id, ...parm };
  }

  // 自定义样式
  private getCustomContentItemStyle({ type, isHeader }: {type: string; isHeader: boolean;}) {
    if (type === 'spuName') {
      return {
        maxLines: 2,
        customProperty: {
          fontWeight: Mach.env.isAndroid ? 400 : 700,
          fontSize: 16,
          fontFamily: 'KeeTa-Bold',
          finalPriceMaxWidth: 1
        }
      };
    } else if (type === 'shopName') {
      return {
        flexShrink: 1,
        flexGrow: 1,
        maxLines: 1,
        customProperty: {
          fontWeight: 400,
          fontSize: 12,
          color: '#222222',
          fontFamily: 'KeeTa-Regular'
        }
      };
    } else if (type === 'spuDesc') {
      return {
        maxLines: 2
      };
    } else if (type === 'spuPrice') {
      return {
        maxLines: 1,
        customProperty: {
          finalPriceMaxWidth: 1000,
          finalPriceStyles: { fontSize: 18 }
        }
      };
    } else if (type === 'spuDynamicTags') {
      return {
        maxLines: 1,
        dynamicTagIsZeroMargin: true
      };
    }

    if (isHeader) {
      return {
        maxLines: 1,
        flexShrink: 0,
      };
    } else {
      return {
        maxLines: 1
      };
    }
  }

  private renderContentItem(content, isHeader: boolean = false) {
    // 店铺名前标签处理
    let handleContent = cloneDeep(content);
    let featureValue; let
      pickUpIconValue;
    let spuDynamicTagsLine = -1;
    const ignoreFlexObj = {};
    handleContent = handleContent.map((row: any[], line) => row.map((item) => {
      if (item.type === 'featureLabel') {
        featureValue = item.data.featureLabel;
      } else if (item.type === 'pickUpIcon') {
        pickUpIconValue = item.data.pickUpIcon;
      } else if (item.type === 'shopName') {
        item.data.featureLabel = featureValue;
        item.data.pickUpIcon = pickUpIconValue;
      } else if (item.type === 'spuDynamicTags') {
        spuDynamicTagsLine = line;
      } else if (item.type === 'spuName' || item.type === 'spuDesc') {
        ignoreFlexObj[line] = true;
      }
      return item;
    }));
    // 动态标签为分割点 置底展示
    let flexLine = spuDynamicTagsLine === -1 ? handleContent.length - 1 : spuDynamicTagsLine;
    flexLine = ignoreFlexObj[flexLine] ? -1 : flexLine;

    const warpStyle = isHeader ? {} : { marginRight: 12, marginTop: 2, marginBottom: 3 };
    return (
      <view className="procuct-content-warp" style={warpStyle}>
        {handleContent.length > 0 && (
          <view className="procuct-content-container">
            {handleContent.map((warp, line) => {
              const lineStyle = isHeader ? {} : { flex: line === flexLine ? 1 : 0, alignItems: 'flex-end', marginBottom: line === handleContent.length - 1 ? 0 : 5 };
              return warp?.length > 0 ? (
                <view key={line} className="procuct-content-item-container" style={lineStyle}>
                  {warp?.map((item, index: number) => {
                    // data
                    const attachmentData = attachments[item?.type];
                    if (attachmentData) {
                      const lastItemType = warp?.[index + 1]?.type;
                      const lastAttachmentData = attachments?.[lastItemType];

                      // spec
                      const headerSpecStyle = item?.type === 'shippingFreeIcon' || item?.type === 'shopName' ? { specType: ContentSpecType.BlankSpace, spec: item?.type === 'shopName' ? 14 : 2 } : { specType: ContentSpecType.Point, spec: 4 };
                      const specStyle = { specType: ContentSpecType.BlankSpace, spec: 5 };

                      // item style
                      const attachmentStyle = this?.getCustomContentItemStyle({ type: item.type, isHeader });

                      return (
                        <attachmentData.attachment
                          key={`${item.type}_${line}_${index}`}
                          itemKey={item?.type}
                          data={item?.data}
                          specStyle={isHeader ? headerSpecStyle : specStyle}
                          style={attachmentStyle}
                          hasLastItem={lastAttachmentData !== undefined}
                        />
                      );
                    }
                    return null;
                  })}
                </view>
              ) : null;
            })}
          </view>
        )}
      </view>
    );
  }

  render() {
    this.observerCellAppear();

    const { apiData } = this.props;
    const { json_data, layout_info } = apiData || {};
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    const {
      shopMainPicUrl, content, pictures, scheme, logo, imgCornerLabel, imgTopRightContent, imgTopContent
    } = json_data || {};

    const picObject = pictures?.[0];
    const topContents = content?.[0] ? [content[0]] : [];
    const lastContents = content?.slice?.(1) || []; // 获取剩余的元素

    const placeholderImg = 'assets://placeholder/icon_placeholder_1:1.png';

    return (
      <view
        className="procuct-container"
        style={{
          marginTop: margin_top || 0,
          marginBottom: margin_bottom || 12,
          marginLeft: margin_left || 16,
          marginRight: margin_right || 16,
        }}
      >
        {/* 分割线上部：商家信息 */}
        {topContents.length > 0 && (
          <view
            className="procuct-header-warp" onClick={() => {
              this.lxReportOnClick(scheme);
            }}
          >
            {/* 头部信息 */}
            {this.renderContentItem(topContents, true)}
            {/* 分割线 */}
            <view className="product-split-line" />
          </view>
        )}

        {/* content */}
        <view
          className="product-info-warp" onClick={() => {
            this.lxReportOnClick(picObject.scheme);
          }}
        >
          {/* 标签 */}
          {this.renderContentItem(lastContents)}

          {/* 商图 不再溢出隐藏 防止影响角落购买按钮 */}
          <view className="product-picture-warp">
            {/* 圆角溢出隐藏 用于控制商图样式 */}
            <view className="product-picture-radius-wrap">
              <image
                className="product-pic"
                src={picObject?.url || shopMainPicUrl || placeholderImg}
                placeholder={placeholderImg}
                error={placeholderImg}
                resizeMode="aspectFill"
              />
              {imgTopRightContent && <GroupMealTag data={imgTopRightContent} />}
            </view>
            {/* 图片区域顶部标签 */}
            {imgTopContent && (
              <image
                className="img-top-content"
                style={{ height: imgTopContent?.height, width: imgTopContent?.width }}
                src={imgTopContent?.picUrl} resizeMode="heightFix" disableCdnOptimization={!!Mach.env.isAndroid}
              />
            )}
            {logo && (<view className="product-logo-warp"><image className="product-logo-image" resizeMode="aspectFit" placeholder={placeholderImg} src={logo} /></view>)}
            {imgCornerLabel && (<view className="product-corner-label-warp" style={{ width: imgCornerLabel.width || 38, height: imgCornerLabel.height || 38 }}><image className="product-corner-label-image" resizeMode="aspectFit" src={imgCornerLabel.picUrl} /></view>)}
          </view>
        </view>
      </view>
    );
  }
}

export default connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(DishCard));
